import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  deleteInvoiceByInvoiceId,
  downloadInvoiceFile,
  getInvoiceById,
  getInvoiceList,
} from "../../../../services/api_services/PaymentService";
import SectionLoader from "../../../../components/global/loader/SectionLoader";
import {
  convertDateAndTimeToString,
  downloadFileFromURL,
  getSelectedBranchId,
} from "../../../../utils/HelperFunctions";
import {
  EnhancedTableHead,
  getComparator,
  stableSort,
} from "../../../../components/dashboard/table_component/TableComponent";
import GlobalData, { invoiceStatus } from "../../../../utils/GlobalData";
import Button from "../../../../components/global/button/Button";
import InvoiceStatus from "../../../../components/dashboard/payment/InvoiceStatus";
import AddPaymentModal from "../../../../modals/payment/AddPaymentModal";
import {
  ROLE_ASSISTANT,
  ROLE_FRONT_DESK_ADMIN,
  SEARCH_RESULT_FOR_INVOICE,
} from "../../../../utils/Constants";
import { toast } from "react-toastify";
import SelectInstructionModal from "../../../../modals/contact/SelectInstructionModal";
import AddInvoiceModal from "../../../../modals/appointment/AddInvoiceModal";
import { getAppointmentsById } from "../../../../services/api_services/AppointmentServices";
import { useLocation } from "react-router-dom";

export default function InvoiceTab(props) {
  const location = useLocation();

  const userRole = JSON.parse(sessionStorage.getItem("UserRole"));
  const orgDetails = JSON.parse(sessionStorage.getItem("OrgDetails"));
  const isPaymentAccessAllowed =
    orgDetails && orgDetails?.isPaymentAccessAllowed
      ? orgDetails?.isPaymentAccessAllowed
      : false;
  const organizationFlagDetails = JSON.parse(
    sessionStorage.getItem("OrgDetails2"),
  );
  const [isBillWithGst, setIsBillWithGst] = useState(
    organizationFlagDetails?.billWithGst ? true : false,
  );

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "Invoice No",
    },
    {
      id: "clientName",
      numeric: false,
      disablePadding: false,
      label: "Patient",
    },
    {
      id: "createDate",
      numeric: false,
      disablePadding: false,
      label: "Create Date",
    },
    {
      id: "subtotal",
      numeric: true,
      disablePadding: false,
      label: "Charges",
    },

    ...(isBillWithGst
      ? [
          {
            id: "cgstVal",
            numeric: true,
            disablePadding: false,
            label: "CGST",
          },
          {
            id: "sgstVal",
            numeric: true,
            disablePadding: false,
            label: "SGST",
          },
        ]
      : []),

    {
      id: "discount",
      numeric: true,
      disablePadding: false,
      label: "Discount",
    },
    {
      id: "total",
      numeric: true,
      disablePadding: false,
      label: "Total",
    },
    {
      id: "balance",
      numeric: true,
      disablePadding: false,
      label: "Due Amount",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
    },

    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
    },
  ];

  useEffect(() => {
    const handleOrgUpdate = () => {
      const updatedOrg = JSON.parse(sessionStorage.getItem("OrgDetails2"));
      setIsBillWithGst(updatedOrg?.billWithGst ? true : false);
    };

    window.addEventListener("orgDetailsUpdated", handleOrgUpdate);

    return () => {
      window.removeEventListener("orgDetailsUpdated", handleOrgUpdate);
    };
    // eslint-disable-next-line
  }, []);

  var id = 0;
  const loading = false;
  const [isExportFileLoading, setIsExportFileLoading] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("id");
  const [rowsPerPage, setRowPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [invoiceListAll, setInvoiceListAll] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const [isPaymentModal, setIsPaymentModal] = useState(false);
  const [Invoice, setInvoice] = useState({});
  const [paymentTypeFilter, setPaymentTypeFilter] = useState("");
  const [fileType, setFileType] = useState("pdf");
  const [selectFileType, setSelectFileType] = useState(false);
  const [showInvoiceInstructionModal, setShowInvoiceInstructionModal] =
    useState(false);
  const [isSelectInvoiceInstructionModal, setIsSelectInvoiceInstructionModal] =
    useState(false);
  const [invoiceToDownload, setInvoiceToDownload] = useState("");
  const [isAddInvoiceModal, setIsAddInvoiceMOdalModal] = useState(false);
  const [appointmentId, setAppointmentId] = useState("");
  const [isEditInvoiceModal, setEditInvoiceModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchData, setSearchData] = useState(location.state?.invoiceNumbers ? location.state?.invoiceNumbers : "");
  const [totalInvoiceCount, setTotalInvoiceCount] = useState();
  const [shouldFetch, setShouldFetch] = useState(false);
  const [appointmentInfo, setAppointmentInfo] = useState({});
  const generateInvoiceWithoutAppointment = true;

  const [
    isGenerateInvoiceWithoutAppointmentModal,
    setIsGenerateInvoiceWithoutAppointmentModal,
  ] = useState(false);

  let orgId =
    sessionStorage.getItem("OrgDetails2") !== null
      ? JSON.parse(sessionStorage.getItem("OrgDetails2"))?.id
      : sessionStorage.getItem("ConsultantDetails") !== null
        ? JSON.parse(sessionStorage.getItem("ConsultantDetails"))
            ?.organizationId
        : 0;

  const consultant = JSON.parse(sessionStorage.getItem("ConsultantDetails"));
  const isConsultantUser = consultant !== null;
  const consultantId = isConsultantUser ? consultant?.id : null;
  const [visitTypeFilter, setVisitTypeFilter] = useState(["HOME", "BRANCH"]);

  async function getAllInvoiceList() {
    const fromDate = dateToMillisAtMidnight(startDate);
    const toDate = dateToMillisAtEndOfDay(endDate);
    setIsLoading(true);
    let data = JSON.stringify({
      fromDate: fromDate,
      toDate: toDate,
      type: paymentTypeFilter ? paymentTypeFilter : "",
      text: searchData,
      status: statusFilter ? statusFilter : "",
      addressId: getSelectedBranchId(),
      visitType: getVisitTypeValue(),
    });
    const response = await getInvoiceList(page, rowsPerPage, data);
    if (response && response.data) {
      setInvoiceListAll(response.data.list);
      setTotalInvoiceCount(response.data.count);
    } else {
      setInvoiceListAll([]);
      setTotalInvoiceCount();
    }

    setIsLoading(false);
  }

  async function getInvoiceByIdHandler(id) {
    let isResponse = false;
    const response = await getInvoiceById(id);
    if (response) {
      setInvoice(response);
      isResponse = true;
    }
    return isResponse;
  }

  useEffect(() => {
    getAllInvoiceList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, shouldFetch]);

  useEffect(() => {
    const handleBranchChange = () => {
      setPage(0);
      setShouldFetch((prev) => !prev);
    };

    window.addEventListener("branchChanged", handleBranchChange);

    return () => {
      window.removeEventListener("branchChanged", handleBranchChange);
    };
  }, []);

  useEffect(() => {
    if (appointmentId) {
      getAppointmentByIdForFrontDeskUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointmentId]);

  useEffect(() => {}, [startDate, endDate]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowPerPage(parseInt(event.target.value, 10));
  };

  function isStartDateBeforeEndDate(startDate, endDate) {
    let start = new Date(startDate);
    let end = new Date(endDate);
    return start <= end;
  }

  async function handleUpdateInvoiceModal(row) {
    id = row.id;
    if (id !== 0) {
      const isResponse = await getInvoiceByIdHandler(id);
      if (isResponse) {
        setAppointmentId(row.appointmentId);
        setEditInvoiceModal(true);
        setIsAddInvoiceMOdalModal(true);
      }
    }
  }

  function handleSearch(e) {
    e.preventDefault();

    setErrorMessage("");

    if (startDate || endDate) {
      if (!startDate) {
        setErrorMessage("Please select start date");
        return;
      }

      if (!endDate) {
        setErrorMessage("Please select end date");
        return;
      }

      if (!isStartDateBeforeEndDate(startDate, endDate)) {
        setErrorMessage("Start date should be less than end date");
        return;
      }
    }
    getAllInvoiceList();
  }

  const resetData = () => {
    setStartDate("");
    setEndDate("");
    setSearchData("");
    setPaymentTypeFilter("");
    setErrorMessage("");
    setStatusFilter("");
    setShouldFetch(!shouldFetch);
    setVisitTypeFilter(["HOME", "BRANCH"]);
  };

  async function handleIsPaymentModal(row) {
    id = row.id;
    setAppointmentId(row.appointmentId);
    setIsPaymentModal(!isPaymentModal);
    if (id !== 0) {
      await getInvoiceByIdHandler(id);
    }
  }

  async function deleteInvoiceByIdHandler(id) {
    const confirmed = window.confirm(
      "Are you sure you want to delete this invoice details?",
    );

    if (confirmed) {
      let response = await deleteInvoiceByInvoiceId(id);
      if (response) {
        getAllInvoiceList();
      }
    }
  }

  function dateToMillisAtMidnight(dateStr) {
    const date = new Date(dateStr);
    date.setHours(0, 0, 0, 0);
    return date.getTime();
  }

  function dateToMillisAtEndOfDay(dateStr) {
    const date = new Date(dateStr);
    date.setHours(23, 59, 59, 999);
    return date.getTime();
  }

  async function downloadInvoiceFileHandler() {
    setIsExportFileLoading(true);
    const fromDateMillis = dateToMillisAtMidnight(startDate);
    const toDateMillis = dateToMillisAtEndOfDay(endDate);

    let data = JSON.stringify({
      fileType: fileType,
      fromDate: fromDateMillis,
      toDate: toDateMillis,
      status: statusFilter,
      text: searchData,
      paymentType: paymentTypeFilter,
      selectedAddressId: getSelectedBranchId(),
      visitType: getVisitTypeValue(),
    });
    const response = await downloadInvoiceFile(data);
    if (response) {
      downloadFileFromURL({
        id: response,
        fileName: `invoices.${fileType}`,
      });
      setSelectFileType(false);
      setFileType("pdf");
    }
    setIsExportFileLoading(false);
  }

  function toggleInvoiceInstructionModal() {
    if (isSelectInvoiceInstructionModal) {
      setIsSelectInvoiceInstructionModal(false);
    }
    setShowInvoiceInstructionModal(!showInvoiceInstructionModal);
  }

  async function getAppointmentByIdForFrontDeskUser() {
    setIsLoading(true);
    const response = await getAppointmentsById(appointmentId);
    if (response) {
      setAppointmentInfo(response);
    }

    setIsLoading(false);
  }

  function handleExportReport() {
    if (!startDate || !endDate) {
      toast.error(
        "Please select start date and end date to export the report file.",
      );
      return;
    } else if (!isStartDateBeforeEndDate(startDate, endDate)) {
      toast.error("Start date should be less than end date");
      return;
    } else if (fileType === "") {
      toast.error("Please select file type");
      return;
    } else {
      downloadInvoiceFileHandler();
    }
  }

  function getVisitTypeValue() {
    if (
      visitTypeFilter.includes("HOME") &&
      visitTypeFilter.includes("BRANCH")
    ) {
      return "ALL";
    }

    if (visitTypeFilter.includes("HOME")) {
      return "HOME";
    }

    if (visitTypeFilter.includes("BRANCH")) {
      return "BRANCH";
    }

    return null;
  }

  return (
    <div className="p-3">
      {loading ? (
        <SectionLoader />
      ) : (
        <>
          <div className="d-flex justify-content-end mb-3">
            <Button
              onClick={() => {
                setIsGenerateInvoiceWithoutAppointmentModal(true);
                setIsAddInvoiceMOdalModal(true);
              }}
              className="secondary "
            >
              Generate Invoice
            </Button>
          </div>

          <form className="mb-3" onSubmit={handleSearch}>
            <div className=" d-flex flex-column flex-md-row justify-content-between flex-wrap gap-1">
              <div className="form-floating col-md-3">
                <input
                  type="search"
                  className={`form-control custom-textarea`}
                  id="floatingInput"
                  placeholder="Search by Invoice No, Name"
                  value={searchData}
                  onChange={(e) => {
                    setPage(0);
                    setSearchData(e.target.value);
                  }}
                />
                <label htmlFor="floatingInput">
                  Search by Invoice No, Name
                </label>
              </div>
              <div className="form-floating col-12 col-md-4 col-lg-1 ">
                <select
                  className="form-select"
                  id="selectStatus"
                  aria-label="Status"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">All</option>
                  {invoiceStatus &&
                    Object.values(invoiceStatus)
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((status) => (
                        <option value={status.value} key={status.value}>
                          {status.name}
                        </option>
                      ))}
                </select>
                <label htmlFor="selectStatus">Status</label>
              </div>
              <div className="form-floating col-12 col-md-4 col-lg-2">
                <select
                  className="form-select"
                  id="selectPaymentType"
                  aria-label="Payment Type"
                  value={paymentTypeFilter}
                  onChange={(e) => setPaymentTypeFilter(e.target.value)}
                >
                  <option value="">All</option>
                  {[...GlobalData.PAYMENT_TYPE, "Credit Wallet"]
                    .sort((a, b) => a.localeCompare(b))
                    .map((type, index) => {
                      return (
                        <option key={`${index}`} value={type}>
                          {type}
                        </option>
                      );
                    })}
                </select>
                <label htmlFor="selectPaymentType">Payment Type</label>
              </div>
              <div className="col-12 col-md-4 col-lg-3">
                <div className="d-flex gap-2 flex-md-row">
                  <div className="form-floating col-6">
                    <input
                      type="date"
                      className="form-control"
                      id="startDate"
                      placeholder=""
                      onChange={(event) => setStartDate(event.target.value)}
                    />
                    <label htmlFor="startDate">From</label>
                  </div>
                  <div className="form-floating col-6">
                    <input
                      type="date"
                      className="form-control"
                      id="endDate"
                      placeholder=""
                      onChange={(event) => setEndDate(event.target.value)}
                    />
                    <label htmlFor="endDate">To</label>
                  </div>
                </div>
                <p className="mt-1 txt-error">{errorMessage}</p>
              </div>

              <div className="mt-2">
                <label className="form-label mb-1">Serviced at</label>

                <div className="d-flex gap-3 flex-wrap">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="homeVisit"
                      checked={visitTypeFilter.includes("HOME")}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setVisitTypeFilter((prev) => [...prev, "HOME"]);
                        } else {
                          setVisitTypeFilter((prev) =>
                            prev.filter((type) => type !== "HOME"),
                          );
                        }
                      }}
                      disabled={isExportFileLoading}
                    />
                    <label className="form-check-label" htmlFor="homeVisit">
                      Home
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="branchVisit"
                      checked={visitTypeFilter.includes("BRANCH")}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setVisitTypeFilter((prev) => [...prev, "BRANCH"]);
                        } else {
                          setVisitTypeFilter((prev) =>
                            prev.filter((type) => type !== "BRANCH"),
                          );
                        }
                      }}
                      disabled={isExportFileLoading}
                    />
                    <label className="form-check-label" htmlFor="branchVisit">
                      Branch
                    </label>
                  </div>
                </div>
              </div>

              <div>
                <Button className="me-2">Filter</Button>
                <Button className="outline" type="reset" onClick={resetData}>
                  Reset
                </Button>

                {userRole &&
                userRole != null &&
                (userRole === ROLE_FRONT_DESK_ADMIN ||
                  userRole === ROLE_ASSISTANT) ? (
                  <>
                    {isPaymentAccessAllowed && (
                      <div>
                        <button
                          className="txt-primary bg-transparent border-0 mt-2"
                          style={{ fontSize: "15px" }}
                          type="button"
                          onClick={() => setSelectFileType(!selectFileType)}
                        >
                          <i className="bi bi-file-earmark-arrow-down" /> Export
                          Invoices
                        </button>
                        {selectFileType && (
                          <>
                            <div className="d-flex flex gap-2">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id="csvFileType"
                                  name="fileType"
                                  checked={fileType === "csv" ? true : false}
                                  value="csv"
                                  onChange={() => setFileType("csv")}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="csvFileType"
                                >
                                  CSV file
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id="pdfFileType"
                                  name="fileType"
                                  value="pdf"
                                  checked={fileType === "pdf" ? true : false}
                                  onChange={() => setFileType("pdf")}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="pdfFileType"
                                >
                                  Pdf File
                                </label>
                              </div>
                              <Button
                                className="small outline"
                                type="button"
                                isLoading={isExportFileLoading}
                                disabled={isExportFileLoading}
                                onClick={() => {
                                  handleExportReport();
                                }}
                                buttonTitle={
                                  isExportFileLoading
                                    ? "Exporting..."
                                    : "Export"
                                }
                              ></Button>
                              <Button
                                className="error small outline"
                                disabled={isExportFileLoading}
                                type="button"
                                title="Close"
                                onClick={() => {
                                  setFileType("pdf");
                                  setSelectFileType(!selectFileType);
                                }}
                              >
                                <i className="bi bi-x-lg"></i>
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div>
                      <button
                        className="txt-primary bg-transparent border-0 mt-2"
                        style={{ fontSize: "15px" }}
                        type="button"
                        onClick={() => setSelectFileType(!selectFileType)}
                      >
                        <i className="bi bi-file-earmark-arrow-down" /> Export
                        Invoices
                      </button>
                      {selectFileType && (
                        <>
                          <div className="d-flex flex gap-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="csvFileType"
                                name="fileType"
                                checked={fileType === "csv" ? true : false}
                                value="csv"
                                onChange={() => setFileType("csv")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="csvFileType"
                              >
                                CSV file
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="pdfFileType"
                                name="fileType"
                                value="pdf"
                                checked={fileType === "pdf" ? true : false}
                                onChange={() => setFileType("pdf")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="pdfFileType"
                              >
                                Pdf File
                              </label>
                            </div>
                            <Button
                              className="small outline"
                              type="button"
                              isLoading={isExportFileLoading}
                              disabled={isExportFileLoading}
                              onClick={() => {
                                handleExportReport();
                              }}
                              buttonTitle={
                                isExportFileLoading ? "Exporting..." : "Export"
                              }
                            ></Button>
                            <Button
                              className="error small outline"
                              disabled={isExportFileLoading}
                              type="button"
                              title="Close"
                              onClick={() => {
                                setFileType("pdf");
                                setSelectFileType(!selectFileType);
                              }}
                            >
                              <i className="bi bi-x-lg"></i>
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </form>

          {isLoading ? (
            <SectionLoader />
          ) : invoiceListAll && invoiceListAll.length ? (
            <>
              <TableContainer id="tableDiv">
                <Table className="tableX" aria-labelledby="tableTitle">
                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={10}
                    headCells={headCells}
                  />
                  <TableBody className="table">
                    {stableSort(
                      invoiceListAll,
                      getComparator(order, orderBy),
                    ).map((row, index) => {
                      return (
                        <TableRow hover tabIndex={-1} key={row.id}>
                          <TableCell data-cell={headCells[0].label}>
                            {row.invoiceNumber}
                          </TableCell>
                          <TableCell
                            className="text-capitalize"
                            data-cell={headCells[1].label}
                          >
                            {row.clientName}
                            {row.isHomeVisit && (
                              <span
                                style={{
                                  backgroundColor: "transparent",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <i className="bi bi-house-door"></i>
                              </span>
                            )}
                          </TableCell>
                          <TableCell data-cell={headCells[2].label}>
                            {convertDateAndTimeToString(row.createDate)}
                          </TableCell>
                          <TableCell
                            data-cell={headCells[3].label}
                            align="right"
                          >
                            {parseFloat(row.subtotal).toFixed(2)}
                          </TableCell>

                          {isBillWithGst && (
                            <>
                              <TableCell
                                data-cell={headCells[4].label}
                                align="right"
                              >
                                {parseFloat(row.cgstVal).toFixed(2)}
                              </TableCell>
                              <TableCell
                                data-cell={headCells[5].label}
                                align="right"
                              >
                                {parseFloat(row.sgstVal).toFixed(2)}
                              </TableCell>
                            </>
                          )}
                          <TableCell
                            data-cell={headCells[6].label}
                            align="right"
                          >
                            {parseFloat(row.discount).toFixed(2)}
                          </TableCell>
                          <TableCell
                            data-cell={headCells[7].label}
                            align="right"
                          >
                            {parseFloat(row.total).toFixed(2)}
                          </TableCell>
                          <TableCell
                            data-cell={headCells[8].label}
                            align="right"
                          >
                            {parseFloat(row.balance) <= 0
                              ? 0
                              : parseFloat(row.balance).toFixed(2)}
                          </TableCell>
                          <TableCell data-cell={headCells[7].label}>
                            <InvoiceStatus status={row.status} />
                            {row.paymentType && (
                              <h6
                                className="text-muted p-0 m-0 bg-transparent"
                                style={{ fontSize: "0.8rem" }}
                              >
                                ({row.paymentType})
                              </h6>
                            )}
                          </TableCell>
                          <TableCell data-cell={headCells[8].label}>
                            {row.status === "Overdue" ? (
                              <div
                                className="p-0 bg-transparent d-flex gap-2 flex-wrap"
                                style={{
                                  width: "max-content",
                                  maxWidth: "40em",
                                }}
                              >
                                <Button
                                  className="success outline small"
                                  data-bs-toggle="tooltip"
                                  title="Download/View"
                                  onClick={() => {
                                    setShowInvoiceInstructionModal(
                                      !showInvoiceInstructionModal,
                                    );
                                    setInvoiceToDownload(row);
                                  }}
                                >
                                  <i className="bi bi-file-earmark-arrow-down"></i>
                                </Button>

                                <Button
                                  className="error outline small"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  type="Delete"
                                  onClick={() =>
                                    deleteInvoiceByIdHandler(row.id)
                                  }
                                >
                                  <i className="bi bi-trash3" />
                                </Button>

                                {row.total === row.balance ? (
                                  <>
                                    <Button
                                      className="outline small"
                                      title="Edit"
                                      type="Edit"
                                      onClick={() =>
                                        handleUpdateInvoiceModal(row)
                                      }
                                    >
                                      <i className="bi bi-pencil-square" />
                                    </Button>
                                  </>
                                ) : null}
                                <Button
                                  className="outline small"
                                  key={row.id + "over"}
                                  onClick={() => handleIsPaymentModal(row)}
                                >
                                  Pay
                                </Button>
                              </div>
                            ) : row.status === "New" ? (
                              <div
                                className="p-0 bg-transparent d-flex gap-2 flex-wrap"
                                style={{
                                  width: "max-content",
                                  maxWidth: "40em",
                                }}
                              >
                                <Button
                                  className="success outline small"
                                  data-bs-toggle="tooltip"
                                  title="Download/View"
                                  onClick={() => {
                                    setShowInvoiceInstructionModal(
                                      !showInvoiceInstructionModal,
                                    );
                                    setInvoiceToDownload(row);
                                  }}
                                >
                                  <i className="bi bi-file-earmark-arrow-down"></i>
                                </Button>

                                <Button
                                  className="error outline small"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  type="Delete"
                                  onClick={() =>
                                    deleteInvoiceByIdHandler(row.id)
                                  }
                                >
                                  <i className="bi bi-trash3" />
                                </Button>

                                <Button
                                  className="outline small"
                                  title="Edit"
                                  type="Edit"
                                  onClick={() => handleUpdateInvoiceModal(row)}
                                >
                                  <i className="bi bi-pencil-square" />
                                </Button>

                                <Button
                                  className="outline small"
                                  key={row.id + "new"}
                                  onClick={() => handleIsPaymentModal(row)}
                                >
                                  Pay
                                </Button>
                              </div>
                            ) : row.status === "Paid" ? (
                              <div
                                className="p-0 bg-transparent d-flex gap-2 flex-wrap"
                                style={{
                                  width: "max-content",
                                  maxWidth: "40em",
                                }}
                              >
                                <Button
                                  className="success outline small"
                                  data-bs-toggle="tooltip"
                                  title="Download/View"
                                  onClick={() => {
                                    setShowInvoiceInstructionModal(
                                      !showInvoiceInstructionModal,
                                    );
                                    setInvoiceToDownload(row);
                                  }}
                                >
                                  <i className="bi bi-file-earmark-arrow-down"></i>
                                </Button>

                                {row.total === 0 && (
                                  <>
                                    <Button
                                      className="error outline small"
                                      data-bs-toggle="tooltip"
                                      title="Delete"
                                      type="Delete"
                                      onClick={() =>
                                        deleteInvoiceByIdHandler(row.id)
                                      }
                                    >
                                      <i className="bi bi-trash3" />
                                    </Button>
                                    <Button
                                      className="outline small"
                                      title="Edit"
                                      type="Edit"
                                      onClick={() =>
                                        handleUpdateInvoiceModal(row)
                                      }
                                    >
                                      <i className="bi bi-pencil-square" />
                                    </Button>
                                  </>
                                )}
                              </div>
                            ) : (
                              <div
                                className="p-0 bg-transparent d-flex gap-2 flex-wrap"
                                style={{
                                  width: "max-content",
                                  maxWidth: "50em",
                                }}
                              >
                                <Button
                                  className="success outline small"
                                  data-bs-toggle="tooltip"
                                  title="Download/View"
                                  onClick={() => {
                                    setShowInvoiceInstructionModal(
                                      !showInvoiceInstructionModal,
                                    );
                                    setInvoiceToDownload(row);
                                  }}
                                >
                                  <i className="bi bi-file-earmark-arrow-down"></i>
                                </Button>
                                <Button
                                  className="error outline small"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  type="Delete"
                                  onClick={() =>
                                    deleteInvoiceByIdHandler(row.id)
                                  }
                                >
                                  <i className="bi bi-trash3" />
                                </Button>

                                <Button
                                  className="outline small"
                                  key={row.id}
                                  onClick={() => handleIsPaymentModal(row)}
                                >
                                  Pay
                                </Button>

                                <Button
                                  className="outline small"
                                  title="Edit"
                                  type="Edit"
                                  onClick={() => handleUpdateInvoiceModal(row)}
                                >
                                  <i className="bi bi-pencil-square" />
                                </Button>
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                className="table-pagination"
                rowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                component="div"
                count={totalInvoiceCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                showLastButton={true}
                showFirstButton={true}
              />
            </>
          ) : (
            <p className="text-center"> {SEARCH_RESULT_FOR_INVOICE}</p>
          )}

          <AddPaymentModal
            show={isPaymentModal}
            onHide={() => setIsPaymentModal(!isPaymentModal)}
            getInvoiceByIdHandler={getInvoiceByIdHandler}
            Invoice={Invoice}
            goToPaymentTab={props.goToPaymentTab}
            appointmentInfo={appointmentInfo}
          />

          <SelectInstructionModal
            show={showInvoiceInstructionModal}
            onHide={toggleInvoiceInstructionModal}
            invoiceToDownload={invoiceToDownload}
          />

          <AddInvoiceModal
            show={isAddInvoiceModal}
            onHide={() => setIsAddInvoiceMOdalModal(!isAddInvoiceModal)}
            isEditInvoiceModal={isEditInvoiceModal}
            isGenerateInvoiceWithoutAppointmentModal={
              isGenerateInvoiceWithoutAppointmentModal
            }
            appointmentId={appointmentId}
            appointmentDetails={appointmentInfo}
            Invoice={Invoice}
            getAllInvoiceList={getAllInvoiceList}
            orgId={orgId}
            consultantId={consultantId}
            setEditInvoiceModal={setEditInvoiceModal}
            setInvoice={setInvoice}
            setAppointmentId={setAppointmentId}
            generateInvoiceWithoutAppointment={
              generateInvoiceWithoutAppointment
            }
            setIsGenerateInvoiceWithoutAppointmentModal={
              setIsGenerateInvoiceWithoutAppointmentModal
            }
            hospitalizationId={Invoice.hospitalizationId}
          />
        </>
      )}
    </div>
  );
}
